export default __webpack_public_path__ + "static/media/mobile_03.206d6808.png";